<template src="@/templates/dashboard/dashboard.html"></template>

<script>
	import RecruitmentDashboard from "@/components/dashboard/RecruitmentDashboardComponent";
	import JobsDashboard from "@/components/dashboard/JobsDashboardComponent";

	export default {
		name: "Dashboard",
		components: {
			RecruitmentDashboard,
			JobsDashboard
		},
		data() {
			return {
				title: "",
				styleObject: {
					"overflow-y": "scroll",
					height: this.getCarouselHeight()
				}
			};
		},
		methods: {
			getCarouselHeight() {
				return window.innerHeight - 134 - 25 + "px";
			}
		}
	};
</script>
<style scoped>
	.el-carousel {
		height: inherit !important;
	}
	
	.card-body {
		height: inherit !important;
	}
	
	.card-body >>> .el-carousel__button {
		background: #e8882f !important;
		width: 4px !important;
		height: 4px !important;
	}
	
	.card-body >>> .el-carousel__item.is-active {
		z-index: 0 !important;
	}
	
	.card-body >>> .el-carousel__indicators {
		z-index: 0 !important;
		width: fit-content !important;
		margin-bottom: -6px !important;
	}
	
	.card-body >>> .el-carousel__indicator {
		padding: 0 4px !important;
	}
	
	.card-body >>> .bg-warning {
		background-color: #dee2e6 !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardComponent.vue